var app     = {};

var config  = {
    windowWidth: $(window).width(),
    windowHeight:$(window).height(),
    fadeSpeed : 200,
    slideSpeed: 300,
    arrowsShowing: false,
    articleGridCon: "#article-grid-section",
    articleGridLink: ".article-grid-link",
    articleCon: "#article-section",
    articleLink: ".article-link",
    pageCon: "#page-section",
    pageLink: ".page-link",
    slider: "#slider",
    currentSection : $("#slider").hasClass(),
    mobBreak: 799
};


(function () {
    "use strict";

    this.mainMenu = function(){

        var $slider = $(config.slider);

        var $menu = $(".menu-body");
        var $backgroundImage = $(".background-image");

        var $menuButton = $(".menu-button");
        var $closeMenuButton = $(".close-menu-button");

        $(".js-menu").off("click");
        $(".js-menu").on("click", function(){

            if( $slider.hasClass("article")){
                app.slideToSection("home");
            }

            TweenLite.to($menu, config.slideSpeed / 750 , {
                scrollTop: $(window).height()
            });

            TweenLite.to($menuButton, config.slideSpeed / 750 , {
                opacity: 0,
                onComplete: function(){
                    $menuButton.css("display", "none");
                    $closeMenuButton.css("display", "block");
                    TweenLite.to($closeMenuButton, config.slideSpeed / 750 , {
                        opacity: 1
                    });
                }
            });

        });

        $(".js-close-menu").off("click");
        $(".js-close-menu").on("click", function(){

            TweenLite.to($menu, config.slideSpeed / 750 , {
                scrollTop: 0
            });

            TweenLite.to($closeMenuButton, config.slideSpeed / 750 , {
                opacity: 0,
                onComplete: function(){
                    $closeMenuButton.css("display", "none");
                    $menuButton.css("display", "block");
                    TweenLite.to($menuButton, config.slideSpeed / 750 , {
                        opacity: 1
                    });
                }
            });

        });

    };


    this.aboutPage = function(){

        var $slider = $(config.slider);

        $(".about-link").on("click", function(){

            TweenLite.to($slider, config.slideSpeed / 1000 , {
                x:"0%"
            });

            return false;

        });

        $(".back-link").on("click", function(){

            TweenLite.to($slider, config.slideSpeed / 1000 , {
                x:"-25%"
            });

            return false;

        });

    };


    this.showShare = function(){

        $(".share-article").addClass("social-open");

        TweenLite.to($(".share-button"), config.fadeSpeed / 500, {
            opacity: 0,
            onComplete: function(){

                $(".share-button").css("display", "none");
                $(".share-links").css("display", "block");

                TweenLite.to($(".share-links"), config.fadeSpeed / 500, {
                    opacity: 1
                });

                setTimeout( function(){
                    TweenLite.to($(".share-link"), config.fadeSpeed / 500 , {
                        opacity: 1
                    });
                }, 100);

            }
        });


    };

    this.hideShare = function(){

        TweenLite.to($(".share-link"), config.fadeSpeed / 500, {
            opacity: 0
        });

        setTimeout( function(){

            TweenLite.to($(".share-links"), config.fadeSpeed / 500 , {
                opacity: 0,
                onComplete: function(){

                    $(".share-links").css("display", "none");
                    $(".share-button").css("display", "block");

                    TweenLite.to($(".share-button"), config.fadeSpeed / 500, {
                        opacity: 0.3,
                        onComplete: function(){
                            $(".share-article").removeClass("social-open");
                            $(".share-button").css("opacity", "");
                        }
                    });

                }
            });

        }, 100);


    };


    // --------------------------------
    // Slide To Section
    // --------------------------------

    this.slideToSection = function(section){

        var $slider = $(config.slider);
        var newSection = {};

        var sections = {
            "article" : {
                sectionClass : "article",
                sectionLocation : "-50%"
            },
            "home" : {
                sectionClass : "home",
                sectionLocation : "-25%"
            },
            "page" : {
                sectionClass : "page",
                sectionLocation : "0%"
            }
        };

        for(var key in sections){
            if (key === section){
                newSection = sections[key];
            }
        }

        if( section !== "article" && config.windowWidth > config.mobBreak){
            app.hideGridHeader();
        }

        $(".article").children(".scroll-section").scrollTop(0);

        TweenLite.to($slider, config.slideSpeed / 750, {
            x: newSection.sectionLocation,
            onComplete: function(){


                $slider.removeClass();
                $slider.addClass(newSection.sectionClass);

                if( section === "article" && config.windowWidth > config.mobBreak){
                    app.showGridHeader()
                }

            }

        });

    };



    this.setPjax = function(){


        $(document).pjax(config.articleGridLink, config.articleGridCon, { fragment: config.articleGridCon, timeout:200000 });
        $(document).pjax(config.articleLink, config.articleCon, { fragment: config.articleCon, timeout:200000 });
        $(document).pjax(config.pageLink, config.pageCon, { fragment: config.pageCon, timeout:200000 });


        $(document).bind("pjax:complete", function (e) {
            e.preventDefault();

            // console.log(e);

            var $from = $(e.relatedTarget);
            var $container = $(e.target);

            TweenLite.to($container, config.fadeSpeed / 750 , {
                opacity: 1
            });

            TweenLite.to($('.loading'), config.fadeSpeed / 750 , {
                opacity: 0,
                onComplete: function(){
                    $('.loading').css('display', 'none');
                }
            });

            if($(".mobile-grid-menu").hasClass("mob-menu-open")){
                app.hideMobileMenu();
            }

            app.pageLoad();

        });

        $(document).on("pjax:popstate", function (e) {

            var pathArray = e.currentTarget.URL.split( "/" );

            // console.log(e);

            var firstSeg = pathArray[3];

            if( firstSeg === "page"){
                app.slideToSection("page");
                TweenLite.to($(e.target), config.fadeSpeed / 750 , {
                    opacity: 0,
                    onComplete: function(){
                        setTimeout(function(){
                            TweenLite.to($(e.target), config.fadeSpeed / 750 , {
                                opacity: 1
                            });
                        },1000);
                    }
                });
            }else if( firstSeg === "" || firstSeg === "category" || $(".mobile-grid-menu").hasClass("mob-menu-open")){
                app.slideToSection("home");
                TweenLite.to($(e.target), config.fadeSpeed / 750 , {
                    opacity: 0,
                    onComplete: function(){
                        setTimeout(function(){
                            TweenLite.to($(e.target), config.fadeSpeed / 750 , {
                                opacity: 1
                            });
                        },1000);
                    }
                });
            }else{
                app.slideToSection("article");
            }

            if($(".mobile-grid-menu").hasClass("mob-menu-open")){
                app.hideMobileMenu();
            }

        });

        $(document).on("pjax:timeout", function (e) {
            console.log("pjax timeout");
        });

    };

    this.clickEvents = function(){

        // Changes to artilce links
        $(config.articleLink).off("click");
        $(config.articleLink).on("click",function (e) {
            var $link = $(this);
            if (!$link.hasClass("is-clicked")) {
                $link.addClass("is-clicked");
                TweenLite.to($(config.articleCon), config.fadeSpeed / 750 , {
                    opacity: 0,
                    onComplete: function(){

                        // trigger the actual link to perform the pjax
                        $link.trigger("click").removeClass("is-clicked");

                        // Slide To article if not already there
                        if ( !$(config.slider).hasClass("article") ){
                            app.slideToSection("article");
                        };
                    }
                });
                $('.loading').css('display', 'block');
                TweenLite.to($('.loading'), config.fadeSpeed / 750 , {
                    opacity: 1,
                    onComplete: function(){
                    }
                });

                return false;
            }

        });

        // Changes to pagination links
        $(config.articleGridLink).off("click");
        $(config.articleGridLink).on("click",function (e) {
            var $link = $(this);

 
            var dataImg = $link[0].dataset.img;
            

            if(!dataImg){
                dataImg = document.querySelector('.background-image').dataset.src;;
            }

            var _img = document.querySelector('.background-image');
            var newImg = new Image;
            newImg.onload = function() {
                _img.src = this.src;
            }
            newImg.src = dataImg;


            if (!$link.hasClass("is-clicked")) {
                $link.addClass("is-clicked");
                TweenLite.to($(config.articleGridCon), config.fadeSpeed / 750 , {
                    opacity: 0,
                    onComplete: function(){
                        
                        $(config.articleGridCon)[0].scrollTo(0,0);

                        // trigger the actual link to perform the pjax
                        $link.trigger("click").removeClass("is-clicked");

                        // If on the page section slide home
                        if ( $(config.slider).hasClass("page") || $(".mobile-grid-menu").hasClass("mob-menu-open")){
                            app.slideToSection("home");
                        };

                    }
                });
                return false;
            }

        });

        $(config.pageLink).off("click");
        $(config.pageLink).on("click", function(){
            var $link = $(this);
            if (!$link.hasClass("is-clicked")) {
                $link.addClass("is-clicked");
                TweenLite.to($(config.pageCon), config.fadeSpeed / 750 , {
                    opacity: 0,
                    onComplete: function(){
                        
                        $(config.articleGridCon)[0].scrollTo(0,0);

                        // trigger the actual link to perform the pjax
                        $link.trigger("click").removeClass("is-clicked");

                        if( $link.attr("href") === "/"){
                            if ( !$(config.slider).hasClass("home") ){

                                app.slideToSection("home");

                                if($link.hasClass("js-show-menu")){
                                    $(".js-menu").trigger("click");
                                }

                            };
                        }else{
                            if ( !$(config.slider).hasClass("page") ){
                                app.slideToSection("page");
                            };
                        }
                    }
                });
                return false;
            }
        });


        $(".share-button").off("click");
        $(".share-button").on("click", function(){
            if( !$(".share-article").hasClass("social-open") ){
                app.showShare();
            }
            return false;
        });

        $(".js-show-mob-menu").off("click");
        $(".js-show-mob-menu").on("click", function(){
            if( !$(".mobile-grid-menu").hasClass("mob-menu-open") ){
                app.showMobileMenu();
            }else{
                app.hideMobileMenu();
            }
            return false;
        });

    };

    // --------------------------------
    // Article Grid Section Functions
    // --------------------------------


    this.showGridHeader = function(){

        var gridHeader = ".grid-header";

        if($(gridHeader).hasClass("hidden")  && $(config.slider).hasClass("article") && !$(gridHeader).hasClass("trans")){
            $(gridHeader).removeClass("hidden");
            $(gridHeader).addClass("trans");
            TweenLite.to($(gridHeader), config.slideSpeed / 750 , {
                top: 0
            });
            TweenLite.to($(config.articleGridCon), config.slideSpeed / 750, {
                "padding-top" : $(gridHeader).height(),
                onComplete: function(){
                    $(gridHeader).removeClass("trans");
                }
            });
        }

    };

    this.hideGridHeader = function(){

        var gridHeader = ".grid-header";

        if(!$(gridHeader).hasClass("hidden") && !$(gridHeader).hasClass("trans")){
            $(gridHeader).addClass("trans");
            $(gridHeader).addClass("hidden");
            TweenLite.to($(gridHeader), config.slideSpeed / 750 , {
                top: $(gridHeader).height() * -1
            });
            TweenLite.to($(config.articleGridCon), config.slideSpeed / 750, {
                "padding-top" : 0,
                onComplete: function(){
                    $(gridHeader).removeClass("trans");
                }
            });
        }

    };

    this.resizeHeader = function(){

        var gridHeader = ".grid-header";
        $(gridHeader).css("top",$(gridHeader).height() * -1);
        $(config.articleGridCon).css("padding-top", 0);

    };

    this.scrollCheckers = function() {

        var articleScroll = {
            obj : $(".article").children(".scroll-section"),
            old_scroll : 0,
            scroll_top : 0,
            scroll_direction: 1
        };

        var articleGridScroll = {
            obj : $(".grid").children(".scroll-section"),
            old_scroll : 0,
            scroll_top : 0,
            scroll_direction: 0
        };

        articleScroll["obj"].off("scroll");
        articleScroll["obj"].on("scroll",function(e) {
            articleScroll.scroll_top = articleScroll["obj"].scrollTop();
            if( articleScroll.scroll_top > articleScroll.old_scroll){
                articleScroll.scroll_direction = 1;
            }else{
                articleScroll.scroll_direction = 0;
            }
            articleScrollFunctions();
            articleScroll["old_scroll"] = articleScroll["obj"].scrollTop();
        });

        articleGridScroll["obj"].off("scroll");
        articleGridScroll["obj"].on("scroll",function(e) {
            articleGridScroll["scroll_top"] = articleGridScroll["obj"].scrollTop();
            if( articleGridScroll.scroll_top > articleGridScroll.old_scroll){
                articleGridScroll.scroll_direction = 1;
            }else{
                articleGridScroll.scroll_direction = 0;
            }
            articleGridScrollFunctions();
            articleGridScroll["old_scroll"] = articleGridScroll["obj"].scrollTop();
        });

        function articleGridScrollFunctions(){

            // Directional scroll functions
            if( articleGridScroll.scroll_direction ){
                // app.hideGridHeader();
            }else{
                // app.showGridHeader();
            }

        };

        function articleScrollFunctions(){

            if( $(".share-article").hasClass("social-open") ){
                app.hideShare();
            }

        };

    };

    this.showMobileMenu = function(){

        $(".mobile-grid-menu").addClass("mob-menu-open");

        $(".mobile-grid-menu").css({
            "left": "-110%",
            "display": "block"
        });

        TweenLite.to($(".mobile-grid-menu"), config.slideSpeed / 750 , {
            left: "0%",
            onComplete: function(){

            }
        });

    };

    this.fullScreenArticle = function(){

        $(".full-screen-open").on("click", function(){
            $("#article-section").addClass("full-screen");
        });

        $(".full-screen-close").on("click", function(){
            $("#article-section").removeClass("full-screen");
        });

    }

    this.hideMobileMenu = function(){

        TweenLite.to($(".mobile-grid-menu"), config.slideSpeed / 750 , {
            left: "-110%",
            onComplete: function(){
                $(".mobile-grid-menu").css({
                    "left": "-110%",
                    "display": "none"
                });

                $(".mobile-grid-menu").removeClass("mob-menu-open");

            }
        });

    };

    this.stackGallery = function(){

        var i = 2;

        $(".stack-image").off("click");
        $(".stack-image").on("click", function(){

            var $parent = $(this).parent();
            var $nextCol = $parent.siblings();
            var $lastChild = $nextCol.children().first();
            i++;

            // $(this).css("z-index", i);

            $nextCol.append($(this));

            // $lastChild.css("z-index", "0");
            $parent.prepend($lastChild)


        });

        $(".close-zoom").off("click");
        $(".close-zoom").on("click", function(event){
            event.stopPropagation();
            $("#article-section").removeClass("locked");
            $(this).css("display", "none");
            $(this).siblings(".zoomed").removeClass("zoomed");
        });

        $(".open-zoom").off("click");
        $(".open-zoom").on("click", function(){
            $("#article-section").addClass("locked");
            $(this).siblings(".zoom-wrap").addClass("zoomed");
            $(this).siblings(".close-zoom").css("display", "block");
        });


    };

    this.newsletter = function(){

      var cookie = app.getCookie('newsletter-signup');

      var parseQueryString = function() {

          var str = window.location.search;
          var objURL = {};

          str.replace(
              new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
              function( $0, $1, $2, $3 ){
                  objURL[ $1 ] = $3;
              }
          );
          return objURL;
      };

      //Example how to use it:
      var params = parseQueryString();

      if(!cookie || params["newsletter"]){
        setTimeout(function(){
          $('.subscribe-overlay').fadeIn();
        }, 10000);
      }

      $('.close-sign-up').on('click', function(){
        $('.subscribe-overlay').fadeOut();
        app.setCookie('newsletter-signup','waiting', 0.5);
      });

      $('.show-sign-up').on('click', function(){
        $('.subscribe-overlay').fadeIn();
      });

      $('.later').on('click', function(){
        $('.subscribe-overlay').fadeOut();
        app.setCookie('newsletter-signup','waiting', 3);
      });

      $('.dont-ask').on('click', function(){
        $('.subscribe-overlay').fadeOut();
        app.setCookie('newsletter-signup','waiting', 100);
      });

      $('#mc-form').ajaxChimp({
          url: 'https://tdcpr.us18.list-manage.com/subscribe/post?u=4f8062e2dd96d6a379b59c8fe&amp;id=b023df26a6&amp;f_id=009207e7f0',
          callback: callbackFunction
      });

      function callbackFunction (resp) {
          if (resp.result === 'success') {
              console.log(resp.result);
              $('.form-wrap').css({
                  'display': 'none'
              });
              $('.success-message').css({
                  'display': 'block'
              });
          }else{
            $('.email-label').html(resp.msg);
          }
      }


    };



    //-----------------------
    //  Page Loaders
    //-----------------------

    this.pageLoad = function(){

        app.scrollCheckers();
        app.clickEvents();
        app.mainMenu();
        app.stackGallery();
        app.fullScreenArticle();

        

        if( $("#slider").hasClass("article") ){

            app.showGridHeader();
        }


    };

    //-----------------------
    //  HELPERS
    //-----------------------

    this.setWindowSizeVars = function() {
        config.windowWidth = $(window).width();
        config.windowHeight = $(window).height();
    };

    this.shuffle = function(o){

        for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
        return o;

    }

    this.setCookie = function(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    this.getCookie= function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    this.eraseCookie = function(name) {
        document.cookie = name+'=; Max-Age=-99999999;';
    }

}).apply(app);

$(document).ready(function() {
    // console.log("Ready");
    app.setPjax();
    app.pageLoad();
    app.newsletter();

});


$(window).on("resize", function() {
    app.setWindowSizeVars();
    app.resizeHeader();
});
